import {useParams} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";

import {Alert, Tab, Tabs} from "react-bootstrap";

import InfoTab from "../../Components/Members/MemberDetails/InfoTab";
import PaymentList from "../../Components/Members/MemberDetails/PaymentList";
import Documents from "../../Components/Members/MemberDetails/Documents/Documents";
import Loading from "../../Components/Layout/Elements/Loading";
import OtherInfoTab from "../../Components/Members/MemberDetails/OtherInfoTab";
import PackagesTab from "../../Components/Members/MemberDetails/PackagesTab";
import {handleErrors} from "../../Components/Errors";
import AuthContext from "../../Contexts/authContext";

const MemberDetail = () => {
    const {id} = useParams()
    const [message, setMessage] = useState(false)
    const [errors, setErrors] = useState({})
    const [generalError, setGeneralError] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [activeTab, setActiveTab] = useState('')

    useEffect(() => {
        console.log(activeTab)
    }, [activeTab])

    const {permissions} = useContext(AuthContext)

    return (

        <>
            {message && <Alert variant={'success'} onClick={() => {
                setMessage(null)
            }} dismissible> {message} </Alert>}
            {errors && typeof errors === 'string' && <Alert variant={'danger'} onClick={() => {
                setErrors(null)
            }} dismissible> {errors} </Alert>}
            {generalError && <Alert variant={'danger'} onClick={() => {
                setGeneralError(null)
            }} dismissible> {generalError} </Alert>}

            <Tabs
                defaultActiveKey="info"
                id="uncontrolled-tab-example"
                className="mb-3"
            >
                <Tab eventKey="info" title="Informazioni Socio" onSelect={() => {
                    setActiveTab('info')
                }}>

                    <InfoTab id={id} setMessage={setMessage} setIsLoading={setIsLoading} setErros={setErrors}
                             isLoading={isLoading}/>
                </Tab>
                {permissions?.payments && <Tab eventKey="pagamenti" title="Pagamenti" onEnter={() => {
                    setActiveTab('pagamenti')
                }}>

                    {activeTab === 'pagamenti' &&
                        <PaymentList id={id} setMessage={setMessage} setIsLoading={setIsLoading} setErros={setErrors}
                                     isLoading={isLoading}/>}

                </Tab>}
                <Tab eventKey="documenti" title="Documenti" onEnter={() => {
                    setActiveTab('documenti')
                }}>
                    {activeTab === 'documenti' &&
                        <Documents id={id} setMessage={setMessage} setIsLoading={setIsLoading} setErros={setErrors}
                                   isLoading={isLoading} errors={errors}/>}


                </Tab>
                <Tab eventKey="infoAggiuntive" title="Informazioni Aggiuntive" onEnter={() => {
                    setActiveTab('infoAggiuntive')
                }}>
                    {activeTab === 'infoAggiuntive' &&
                        <OtherInfoTab id={id} setMessage={setMessage} setIsLoading={setIsLoading} setErros={setErrors}
                                      errors={errors} isLoading={isLoading}/>}


                </Tab>
                <Tab eventKey="pacchetti" title="Pacchetti" onEnter={() => {
                    setActiveTab('pacchetti')
                }}>
                    {activeTab === 'pacchetti' &&
                        <PackagesTab id={id} setMessage={setMessage} setIsLoading={setIsLoading} setErrors={setErrors}/>}
                </Tab>

            </Tabs>
            {isLoading && <Loading/>}
        </>

    )
}

export default MemberDetail